module.exports = __webpack_public_path__ + "img/RX-RAD-DIGI-Moviles-2.39f9c75f.png";